import { render } from "./associationAdministrator.vue?vue&type=template&id=c06d6c38&scoped=true"
import script from "./associationAdministrator.vue?vue&type=script&lang=js"
export * from "./associationAdministrator.vue?vue&type=script&lang=js"

import "./associationAdministrator.vue?vue&type=style&index=0&id=c06d6c38&lang=scss&scoped=true"
import "./associationAdministrator.vue?vue&type=style&index=1&id=c06d6c38&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c06d6c38"]])

export default __exports__